import { useEffect, useState } from 'react';
import FeatureToggleService from '../../../../services/FeatureToggleService';
import { DEU_AI_ENABLED } from '../../../../shared/FeatureToggleKeys';
import { BillingMetrics } from '../../../../shared/BillingMetrics';

export const useDeuAiEnabled = (): boolean => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkFeatureFlag = async () => {
      const deuAiEnabled = await FeatureToggleService.isFeatureToggleEnabled(DEU_AI_ENABLED);

      if (isMounted) {
        setIsEnabled(Boolean(deuAiEnabled));
      }
    };

    checkFeatureFlag();

    return () => {
      isMounted = false;
    };
  }, []);

  return isEnabled;
};

export const buildAdvancedDeuMetricIds = (isDeuAiEnabled: boolean): string => {
  const baseMetricIds = [
    BillingMetrics.dailyEngagedUser,
    BillingMetrics.prospectConversation,
    BillingMetrics.activeMessage,
  ];

  const additionalMetric = isDeuAiEnabled
    ? BillingMetrics.dailyEngagedUserAI
    : BillingMetrics.userConversation;

  return [...baseMetricIds, additionalMetric].join(';');
};
